export const conditionalRowStyles = [
  {
    when: (row: any) => row.id % 2 === 0,
    style: {
      backgroundColor: "#f6f7f9",
      color: "#1E1E1E",
    },
  },
];
